import { apiRequest } from "../util/apiUtils";

export const dynamicFormList = async (params) => {
  try {
    const res = await apiRequest("get", `form/list`, {
      queries: params,
    });
    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const dynamicFormDetails = async (params) => {
  try {
    const res = await apiRequest("get", `form/detail/${params?.id}`, {
      queries: {
        ...(params?.type && { type: params?.type }),
      },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const dynamicFormAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `form/${payload?.id ? `section-edit/${payload?.id}` : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const dynamicFieldAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `form/${payload?.id ? `field-edit/${payload?.id}` : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const dynamicFormDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `form/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const formOrdering = async (payload) => {
  try {
    const res = await apiRequest("patch", `form/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
